module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Ballers-S1.5b0a550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Ballers-S1.jpg
// module id = G82C
// module chunks = 0